import {Link} from 'react-router-dom';
import s from './TourCardIndu.module.scss';
import StarRating from '../../components/StarRating/StarRating';
import LazyLoad from 'react-lazyload';
import ImageWithPlaceholder from "../Image/ImageWithPlaceholder";
import React, {useEffect, useState} from "react";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import {
    ArrowForwardIosOutlined,
    FavoriteBorderOutlined,
    FavoriteOutlined,
    GppGoodOutlined,
    StarOutlined
} from "@mui/icons-material";
import {isInWishlist, toggleWishlist} from '../../components/wishList/wishlist';

const TourCardIndividual = ({item, loading}) => {
    const rezdyId = item?.rezdy_id || item?.rezdyId;
    const [isFavorite, setIsFavorite] = useState(() => isInWishlist(rezdyId));


    useEffect(() => {
        setIsFavorite(isInWishlist(rezdyId));
    }, [rezdyId]);

    const SkeletonCard = () => {
        return (
            <div className={`${s.cards} ${s.skeleton}`}>
                <div className={s.imageWrapper}>
                    <div className={s.skeletonImage}></div>
                </div>

                <div className={s.detailsContainer}>
                    <div className={s.skeletonTitle}></div>

                    <div className={s.skeletonRating}></div>

                    <div className={s.tags}>
                        <div className={s.skeletonTag}></div>
                        <div className={s.skeletonTag}></div>
                        <div className={s.skeletonTag}></div>
                    </div>

                    <div className={s.skeletonText}></div>
                    <div className={s.skeletonText}></div>

                    <div className={s.spacer}></div>

                    <div className={s.skeletonPrice}></div>
                </div>
            </div>
        );
    };
    if (loading) return <SkeletonCard/>;

    if (!item) return null;
    const tourId = item.tour_id || item.tourId;
    const tourCode = item.tour_code;
    const image = item.images?.[0] ?? item.image1;
    const title = item.title;
    const rating = item.rating ?? 0;
    const reviewCount = item.reviewCount ?? item.review_count ?? 0;
    const tags = item.tags ?? [];
    const details = item.details ?? '';
    const showTourCardLabel = item.show_tour_card_label;
    const showDiscountPrecentage = item.show_discout_precentage;
    const tourCardLabel = item.tour_card_label;

    const salePrice = Math.floor(item.salePrice ?? item.sale_price ?? 0);
    const regularPrice = Math.floor(item.regularPrice ?? item.regular_price ?? 0);
    const discountRate = regularPrice > 0 ? Math.round(((regularPrice - salePrice) / regularPrice) * 100) : 0;


    const formatPrice = (price) =>
        new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'AUD'
        }).format(price || 0);

    return (
        <div>
            <div className={s.cards}>
                <div className={s.imageWrapper}>
                    {showTourCardLabel === 1 &&
                        tourCardLabel?.trim() !== '' && (
                            <div className={s.lowestBadge}>
                                <StarOutlined/> {tourCardLabel}
                            </div>
                        )}
                    <button
                        type="button"
                        className={`${s.wishlistButton} ${
                            isFavorite ? s.wishlisted : ''
                        }`}
                        onClick={() => {
                            const result = toggleWishlist(rezdyId);
                            setIsFavorite(result.isFavorite);
                        }}
                        aria-label={
                            isFavorite
                                ? "お気に入りから削除"
                                : "お気に入りに追加"
                        }
                    >
                        {isFavorite
                            ? <FavoriteOutlined/>
                            : <FavoriteBorderOutlined/>
                        }
                    </button>
                    <Link to={`/tours/${tourId}`}>
                        <LazyLoad height={200} offset={100} once>
                            <ImageWithPlaceholder key={`${tourId}-${image}`} src={image} alt={title}
                                                  className={s.image}/>
                        </LazyLoad>
                    </Link>
                </div>

                <div className={s.detailsContainer}>
                    <div className={s.detailsWrapper}>

                        <Link to={`/tours/${tourId}`}>
                            <h3 className={s.title}>{title}</h3>

                        </Link>
                        {tourCode && <p className={s.tourCode}>TOUR CODE: {tourCode}</p>}
                        <div className={s.rating}>
                            <StarRating score={rating}/>
                            <p className={s.rate}>{rating}</p>
                            <p className={s.count}>({reviewCount})</p>
                        </div>

                        <Link
                            to={`/review/${tourId}`}
                            className={s.ratingLink}
                            state={{
                                breadcrumbItems: [
                                    {name: 'ホーム', link: '/'},
                                    {name: `${title}の口コミ`, link: ''}
                                ]
                            }}
                        />

                        <div className={s.tags}>
                            {tags.map((tag, tagIndex) => (
                                <span key={tagIndex} className={s.tag}>
                      {tag.name ?? tag}
                    </span>
                            ))}
                        </div>

                        <p className={`${s.details}`}>{details}</p>
                        <div className={`${s.spacer}`}></div>
                    </div>
                    <div className={s.priceArea}>


                        <div className={s.priceRow}>
                            <div className={s.priceSection}>
      <span className={s.salePrice}>
                                {formatPrice(discountRate > 0 ? salePrice : regularPrice)}
                            </span>
                                {discountRate > 0 && (

                                    <span className={s.regularPrice}>
                                        {formatPrice(regularPrice)}
                                    </span>


                                )}
                            </div>

                            {discountRate > 0 &&


                                showDiscountPrecentage === 1 && (
                                    <div className={s.offerPercent}>
                                        {discountRate}%OFF
                                    </div>)
                            }


                        </div>

                        <Link
                            to={`/tours/${tourId}`}
                            className={s.bookButton}
                        >
                            <div className={s.bookNowBtn}><CalendarMonthIcon/>
                                最安値で予約する
                            </div>
                            <ArrowForwardIosOutlined/>
                        </Link>

                        <div className={s.lowPriceText}>
                            <GppGoodOutlined/> 即時予約OK・日本語サポート対応
                        </div>

                    </div>
                </div>
            </div>
        </div>

    );
};

export default TourCardIndividual;
